import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'

import { useSelector, useDispatch } from 'react-redux'

import mapboxgl from 'mapbox-gl';


/**
 * Managing the layers used to draw viewport item trajectories. 
 * Layer names and trajectory-layer assignments are defined in the viewport item condfig
 * object (fetched from db). 
 */
export default function ViewportItemTrajectoryLayers(props) {

  const map = useSelector((state) => state.ui.map)
  const items = useSelector((state) => state.viewport.viewport.items)

  // cursor shaope changing event handlers: 
  const pointerCursor = () => {
    map.getCanvas().style.cursor = 'pointer';
  }
  const normalCursor = () => {
    map.getCanvas().style.cursor = '';
  }      

  var layers = new Set()

  // managing map layers: 
  // --------------
  useEffect(() => {
    // only update when necessary: 
    if ( (map) && (items) ) {            
      // collect layers defined in item configs: 
      items.map( (item, index) => {
        const layerId = JSON.parse(item.config).layerId
        if (layerId) layers.add(layerId)
      })

      var beforeLayerName = ( map.getLayer('lastStates') ? 'lastStates' : null ) ;       
      // add a placeholder layer: 
      map.addSource('trajectory-placeholder', {
        type: 'geojson',
        data: {
          "type": "FeatureCollection",
          "features": []
        }
      });
      map.addLayer({
        id: "trajectory-placeholder",
        source: "trajectory-placeholder",
        type: "line",
      }, beforeLayerName);
      // add layers: 
      layers.forEach( (layerId) => {
        if (!  map.getSource(layerId))  {
          map.addSource(layerId, {
            type: 'geojson',
            lineMetrics: false, // true,
            tolerance: 0.1, // Douglas-Peucker simplification tolerance 
                            // (higher means simpler geometries and faster performance).
                            // Defaults to 0.375 --> 0.5 --> 0.1 
            buffer: 0, // Optional number between 0 and 512 inclusive. Defaults to 128. 
                       // Size of the tile buffer on each side.  
            // cluster: true, 
            data: {
              "type": "FeatureCollection",
              "features": []
            }
          });
        }
        if (! map.getLayer(layerId)) {
          map.addLayer({
            id: layerId,
            type: "line",
            source: layerId,
            paint: {
              'line-color': ['get', 'color'],
              'line-width': ['get', 'line-width'],
              'line-opacity': 0.8
              // TODO: data-driven line-gradient not supported yet
            },
            layout: {
              'line-cap': 'round',  // 'round', 'square', 'butt'
              'line-join': 'round', // 'bevel' // 'miter'
              //'icon-allow-overlap': true,
              // 'text-allow-overlap': true 
            },
            minzoom: 0,
            maxzoom: 24
          }, beforeLayerName);
        } 

      })
      
      // add layer if not present already
      //map.on('mouseenter', trajectoryId, function(e) {
      //  pointerCursor() ;
      //});
      //// Change it back to a pointer when it leaves.
      //map.on('mouseleave', trajectoryId, function() {
      //  normalCursor() ;  
      //});


      //map.on('click', trajectoryId, clickHandler)

      //map.on('styledata', function() {
      //  // TODO: do we need forceUpdate? 
      //  //this.forceUpdate()  ;
      //}.bind(this)) 
    }

    // cleanup: 
    return () => {
      if ((typeof map !== "undefined") ) {
        try {
          if (map.getLayer('trajectory-placeholder')) map.removeLayer('trajectory-placeholder')
          if (map.getSource('trajectory-placeholder')) map.removeSource('trajectory-placeholder')          
        }
        catch (e) {
          ;
        }
        layers.forEach( (layerId) => {
          try {
            if (map.getLayer(layerId)) map.removeLayer(layerId)
            if (map.getSource(layerId)) map.removeSource(layerId)          
          }
          catch (e) {
            console.log("ViewportTrajectoryLayers: map style not ready, unable to remove layers. ")
          }
          // remove layer when not displayed

          //  map.off('click', trajectoryId, clickHandler);
          //  //map.off('styledata', this.forceUpdate)
          //  map.off('mouseenter', trajectoryId, pointerCursor)
          //  map.off('mouseleave', trajectoryId, normalCursor)  
        })
      }
    }
  }, [map, items])

  // to force map update:
  // this.map.resize()
  return  
}